import React from 'react';

import styles from './Footer.module.css';

const Footer = () => (
  <div className={styles.container}>
    <a href="http://status.sierrawireless.com" alt="Airvantage Server Status" target="_blank" rel="noopener noreferrer">
      Server Status
    </a>
    {window.location.pathname.includes('/user-notice') ? <></> :
      <a href="https://www.sierrawireless.com/privacy/" alt="Privacy Policy" target="_blank" rel="noopener noreferrer">
        Privacy Policy
      </a>
    }
    <a href="https://www.sierrawireless.com/support/login-support/" alt="Support" target="_blank" rel="noopener noreferrer">
      Need help?
    </a>
  </div>
);

export default Footer;
